// Helper unduhan file di sisi klien (CSV) & cetak dokumen (print window).

// Escape satu sel CSV.
const cell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

// Bangun & unduh file CSV dari header + baris (array of array).
export function downloadCsv(filename, headers, rows) {
  const bom = "﻿"; // agar Excel membaca UTF-8 dengan benar
  const content = bom + [headers, ...rows].map((r) => r.map(cell).join(",")).join("\r\n");
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}

// Buka jendela cetak berisi HTML (dipakai untuk surat jalan, dsb.).
// `opts.watermark` = { text, color } menampilkan cap diagonal (mis. status "LUNAS").
export function printHtml(title, bodyHtml, opts = {}) {
  const w = window.open("", "_blank", "width=900,height=650");
  if (!w) return false;
  const wm = opts.watermark;
  const watermarkHtml = wm
    ? `<div style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-28deg);
         font-size:110px;font-weight:800;letter-spacing:8px;color:${wm.color || "#1f5136"};
         opacity:.12;z-index:0;pointer-events:none;white-space:nowrap;text-transform:uppercase">${wm.text}</div>`
    : "";
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${title}</title>
    <style>
      *{font-family:Arial,Helvetica,sans-serif;color:#2b2b26}
      body{padding:28px}
      h1{font-size:20px;margin:0 0 4px}
      .muted{color:#6b6b63;font-size:12px}
      table{width:100%;border-collapse:collapse;margin-top:16px;font-size:12px;position:relative;z-index:1}
      th,td{border:1px solid #d9d2c5;padding:8px;text-align:left}
      th{background:#f5f0e6}
      .right{text-align:right}
      .doc-body{position:relative;z-index:1}
      @media print{.noprint{display:none}}
    </style></head><body>${watermarkHtml}<div class="doc-body">${bodyHtml}</div>
    <div class="noprint" style="margin-top:24px"><button onclick="window.print()" style="padding:8px 16px;background:#1f5136;color:#fff;border:0;border-radius:8px;cursor:pointer">Cetak</button></div>
    </body></html>`);
  w.document.close();
  return true;
}
